import SetRoute from '../services/setRoute';

export const fetchCollateralRequest = (
    fetch,
    param = '',
) => (
    {
        payload: {
            dataset: 'collateral_request',
            action: 'get',
            route: SetRoute + `/api/v1/collateral_requests${param}`,
            data: {},
        },
        fetch,
    }
);

export default fetchCollateralRequest;
